"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createTweekClient_1 = require("./createTweekClient");
var TweekClientWithFallback_1 = __importDefault(require("./TweekClientWithFallback"));
function createTweekClientWithFallback(_a) {
    var urls = _a.urls, config = __rest(_a, ["urls"]);
    var clients = urls.map(function (baseServiceUrl) { return createTweekClient_1.createTweekClient(__assign({ baseServiceUrl: baseServiceUrl }, config)); });
    return new TweekClientWithFallback_1.default(clients);
}
exports.createTweekClientWithFallback = createTweekClientWithFallback;
//# sourceMappingURL=createTweekClientWithFallback.js.map


// WEBPACK FOOTER //
// ../../src/TweekClient/createTweekClientWithFallback.ts